<template>
  <div class="referred">
    <v-card-text >

        <div class="req-list" >
          <div class="req-card" v-on:click="goToDetail(item)" v-for="item in request_items" :key="item.Id">
            <div>
              <v-row>
                <v-col cols="8" style="padding: 5px">
                  <label  style="font-weight: bold">{{item.CreatedTime}}</label>

                </v-col>
                <v-col cols="4" class="text-left" style="padding: 5px">

                </v-col>
              </v-row>
              <hr>
              <div class="flex-no-wrap justify-space-between">
                <div>

                  <div
                    class="req-name"
                    v-text="item.QuestionTitle"
                  ></div>

                  <span>
                    <span style="font-weight: bold">
                    {{ item.QuestionBody }}
                    </span>
                  </span>

                  <div>
                    <div v-if="item.IsDone==true" class="status">تایید شده</div>
                    <div v-if="item.IsDone==false" class="status">در حال بررسی</div>
                  </div>
                </div>

              </div>

            </div>

          </div>

        </div>

      <infinite-loading @infinite="infiniteHandler" v-if="show_loading">
        <div slot="no-more">اطلاعاتی برای نمایش وجود ندارد</div>
      </infinite-loading>

    </v-card-text>
  </div>

</template>
<script>
  import InfiniteLoading from 'vue-infinite-loading';
  import {bus} from "../../main";
  export default {
    props:[
      'passing_data'
    ],
    data() {
      return {
        list: [],
        errors: [],
        post_items:[],
        selected_post:0,
        selected_branch:0,
        request_items:[],
        last_request_items:[],
        show_loading: false,
        page: 0,
        rules: {
          required: value => !!value || 'الزامی',
          fullName: value => value.length <= 30 || 'ماکسیمم 30 کاراکتر می باشد.',
          PersianFullName: value => {
            const pattern = /^[پچجحخهعغآ؟.،آفقثصضشسیبلاتنمکگوئدذرزطظژ!!ؤإأءًٌٍَُِّ\s]+$/
            return pattern.test(value) || 'نام و نام خانوادگی فارسی نیست.'
          },
          mobile: value => {
            const pattern = /^(\+98|0098|98|0)?9\d{9}$/
            return pattern.test(value) || 'فرمت موبایل صحیح نیست.'
          },
        },
        first: true,
      }
    },
    components: {
      InfiniteLoading,
    },
    watch: {

    },
    mounted() {
      this.get_final_requests();
    },

    methods: {
      goToDetail (item) {
        // var passing_data = JSON.parse(localStorage.getItem('request_data'));
        // passing_data.cat_id = item_id;
        // localStorage.setItem("request_data",JSON.stringify(passing_data));
        if(item.IsDone==true){
          this.$router.push({ name: 'QuestionInfo', params: {rec_id:item.Id} })

        }else{
          bus.$emit('show_toast', [1500, "سوال شما هنوز تایید نشده است"])

        }

      },
      get_request_address (item) {
       var address = "";
       if(item.CityName != null){
         address +=  item.CityName+" ";
       }
       if(item.AreaName != null){
         address +=  item.AreaName+" ";
       }
       return address
      },

      get_final_requests($state) {
        var self = this;
        var user_id = JSON.parse(localStorage.getItem("profile")).UserId
        const send_data = {
          UserId: user_id,
          Count:this.page,
        };
        // this.axios.post('/Register' , send_data,{
        this.axios.post('/GetQuestions', send_data, {})
          .then(response => {
            if (response.data.error == 0) {
              response.data.questions.forEach(function (number) {
                self.request_items.push(number);
                self.last_request_items.push(number);
              });
              if(self.first){
                self.first = false;
                // self.infiniteHandler()

              }
              if($state !=null){
                if(self.last_request_items.length>0){
                  console.log("loaded called")
                  $state.loaded();
                }else{
                  console.log("complete called")

                  $state.complete();
                }
              }
            }
          }).catch(e => {
          this.errors.push(e);
        })

      },
      infiniteHandler($state) {
        var self =this;
        console.log("first is "+this.first);
       if(this.first){
         // $state.loaded();
         setTimeout(() => {

           $state.loaded();
         }, 1000);
         return false;
       }

        console.log("hiii"+ self.last_request_items.length)
        setTimeout(() => {

          // if (self.last_request_items>0 ) {
            self.page += 1;
            self.get_pre_requests($state);
            // $state.loaded();
          //
          // } else {
          //   $state.complete();
          //   console.log("completed")
          // }
          }, 1000);


        },
    }
  }
</script>
<style>
  .v-application .headline {
    font-size: 1rem !important;
    font-weight: 400;
    line-height: 2rem;
    letter-spacing: normal !important;
    font-family: "IRANSans" !important;
  }
</style>
